import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'

const Summary = ({ creationMode, type, name, notes }) => {
  const { t } = useTranslation(['Wizard', 'WizardPlatform'])

  const sections = [
    {
      title: 'WizardPlatform:CreationMode',
      detail: t(`WizardPlatform:${creationMode}`)
    },
    {
      title: 'WizardPlatform:ScenarioType',
      detail: t(type)
    },
    {
      title: 'WizardPlatform:ScenarioName',
      detail: name
    }
  ]
  const notesSummary = {
    title: 'WizardPlatform:NotesSummary',
    detail: notes
  }

  const renderSections = () =>
    sections.map(
      ({ title, detail }) =>
        !isEmpty(detail) && (
          <div key={`key-${title}`}>
            <h5>{t(title)}</h5>
            <p>{detail}</p>
          </div>
        )
    )
  return (
    <Fragment>
      <header>
        <h5>{t('WizardPlatform:RecapHeading')}</h5>
      </header>
      <div className='sections-wrapper'>
        <section>{renderSections()}</section>
        <section>
          {!isEmpty(notesSummary.detail) && (
            <div key={`key-${notesSummary.title}`}>
              <h5>{t(notesSummary.title)}</h5>
              <p>{notesSummary.detail}</p>
            </div>
          )}
        </section>
      </div>
    </Fragment>
  )
}

Summary.propTypes = {
  creationMode: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  notes: PropTypes.string
}

Summary.defaultProps = {
  creationMode: '',
  type: '',
  name: '',
  notes: ''
}

export default Summary
